<div class="inside-loading"><img class="img-fluid" src="@/assets/images/preloader.svg" alt="preloader"></div>